import React from 'react';
import PropTypes from 'prop-types';

import './modal.scss';

// The show prop determines if the
// modal is displayed and is controlled by the parent view / component

// The toggle function is passed in by the parent and determines when the modal toggles on and off.

class Modal extends React.Component {
  componentDidUpdate() {
    window.document.documentElement.style.overflow = this.props.show ? 'hidden' : '';
  }
  render() {
    if (this.props.show) {
      return (
        <div className="modal-cover">
          <div className="modal">
            {/* eslint-disable-next-line */}
            <img alt="x" onClick={this.props.toggle} className="modal-close" src="x.svg" />
            <div className="modal-content">
              {this.props.children}
            </div>
          </div>
        </div>
      );
    }
    return null;
  }
}

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  show: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
};

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal/index.jsx